import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Center, Flex, Image, mode, Text, useColorMode } from '@abb/uikit';
import React from 'react';
export const EmptyTabPanel = (param)=>{
    let { title, content } = param;
    const colorMode = useColorMode();
    return /*#__PURE__*/ _jsx(Center, {
        h: "420px",
        children: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: 'column',
            justifyContent: "center",
            alignItems: 'center',
            children: [
                /*#__PURE__*/ _jsx(Image, {
                    src: "/images/empty-notification.svg",
                    alt: "logo",
                    h: "80px",
                    mb: '32px'
                }),
                /*#__PURE__*/ _jsx(Text, {
                    fontSize: "20px",
                    fontWeight: 600,
                    p: "0px 16px",
                    color: mode('gray.700', 'white')({
                        colorMode
                    }),
                    position: "sticky",
                    children: title
                }),
                /*#__PURE__*/ _jsx(Text, {
                    fontSize: "14px",
                    fontWeight: 300,
                    p: 1,
                    color: mode('gray.700', 'white')({
                        colorMode
                    }),
                    children: content
                })
            ]
        })
    });
};
